module.exports = "../fonts/vendor/vendor/typeface-poppins/files/poppins-latin-400italic.woff?9c9695b08b40f038891a8445c18f05ce";